export default "__VITE_ASSET__DqVGb1i1__"